import * as R from "ramda";

import moment from "moment";
import React from "react";
import CSSModules from "react-css-modules";

import { CAPTION_STATES } from "PortalHub/ActionComponents/constants";
import { CARD_ACTIONS } from "../constants";

import { ActionItem } from "PortalHub/ActionComponents/View";
import { Text3 } from "components/Base";
import Table, { TableWrapper } from "ui-kit/Table/View";

import styles from "./styles.scss";

import { mapActionItemStatus } from "../utils";

const formButtons = [
  { label: "Submit", id: CARD_ACTIONS.SUBMIT_FORM, primary: true }
];

const decorate = CSSModules(styles);

const FormType = ({ task = {} }) => (
  <ActionItem
    title={task.name}
    caption={`${
      task.status === "incomplete" ? "Not submitted" : "Submitted"
    } • Due ${moment().isBefore(task.due_raw) ? "in" : ""} ${moment(
      task.due_raw
    ).fromNow()}`}
    captionState={
      task.required ? CAPTION_STATES.REQUIRED : CAPTION_STATES.OPTIONAL
    }
    icon={
      task.status === "incomplete" &&
      moment().isAfter(task.due_raw) &&
      !task.required
        ? "lock"
        : ""
    }
    status={mapActionItemStatus({
      status: task.status,
      required: task.required,
      pastDue: moment().isAfter(task.due_raw)
    })}
    expandable
    buttons={formButtons}
    id={task.id}
    data={task}
  >
    <div styleName="people-card">
      <Text3 bold>Due Date: </Text3>
      <Text3>{moment(task.due_at).format("MMMM D, YYYY @ hha z")}</Text3>
      {task.description ? (
        <>
          <Text3 bold>Description: </Text3>
          <div dangerouslySetInnerHTML={{ __html: task.description }} />
        </>
      ) : null}
      {task.submissions && !R.isEmpty(task.submissions) ? (
        <>
          <Text3 bold>Submissions: </Text3>

          <TableWrapper
            instanceId={task.id}
            loading={false}
            style={{ flex: 1 }}
          >
            <Table
              showOpenRecord
              showCheckbox={false}
              canEditCells={false}
              instanceId={task.id}
            />
          </TableWrapper>
        </>
      ) : null}
    </div>
  </ActionItem>
);

export default decorate(FormType);
